// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"627":"a39e1dfb5caf504c","644":"2c040b376c804e8c","646":"e4b206fd76023ff3"}[chunkId] + ".js";
};